import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { BillInterface } from '../../models/bill.interface';
import { SetSelectedBill } from '../../store/actions/bills.actions';
import { PriceFormatService } from '../../../shared/services/price-format.service';

@Component({
  selector: 'app-modal-bills-list',
  templateUrl: './modal-bills-list.component.html',
  styleUrls: ['./modal-bills-list.component.css'],
  standalone: false
})
export class ModalBillsListComponent implements OnInit {

  @Input()
  bills: Array<BillInterface>;

  @Input()
  visibility: boolean = true;

  constructor(private store: Store<any>, public priceFormatService: PriceFormatService) {}

  ngOnInit() {
  }

  setSelectedBill(bill?: BillInterface) {
    this.store.dispatch(new SetSelectedBill(bill));
    this.visibility = false;
  }
}
